import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import { history } from '../history'
import reduxForm from './reduxForm'
import v1contextMenu from './v1contextMenu'

import airports from './airports'
import flights from './flights'
import passengers from './passengers'
import ssrs from './ssrs'
import bookings from './bookings'
import users from './users'
import tourOperators from './tourOperators'
import seatTrade from './seatTrade'
import errors from './errors'
import notifications from './notifications'
import search from './search'
import ui from './ui'
import serviceStatus from './service'

export default combineReducers({
  ...ui,
  router: connectRouter(history),
  form: reduxForm,
  v1contextMenu,
  ...airports,
  ...passengers,
  ...ssrs,
  ...bookings,
  ...users,
  ...tourOperators,
  ...seatTrade,
  ...errors,
  ...notifications,
  ...search,
  flights: flights.flights,
  ...serviceStatus,
})
